var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanding2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 300",
    width: 900,
    height: 300,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28L82 28L82 46L164 46L164 40L245 40L245 55L327 55L327 28L409 28L409 25L491 25L491 58L573 58L573 43L655 43L655 31L736 31L736 37L818 37L818 49L900 49L900 31L900 0L900 0L818 0L818 0L736 0L736 0L655 0L655 0L573 0L573 0L491 0L491 0L409 0L409 0L327 0L327 0L245 0L245 0L164 0L164 0L82 0L82 0L0 0Z",
    fill: "#007feb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67L82 67L82 88L164 88L164 67L245 67L245 73L327 73L327 55L409 55L409 52L491 52L491 82L573 82L573 76L655 76L655 58L736 58L736 70L818 70L818 91L900 91L900 79L900 29L900 47L818 47L818 35L736 35L736 29L655 29L655 41L573 41L573 56L491 56L491 23L409 23L409 26L327 26L327 53L245 53L245 38L164 38L164 44L82 44L82 26L0 26Z",
    fill: "#007be9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 106L82 106L82 151L164 151L164 148L245 148L245 136L327 136L327 130L409 130L409 94L491 94L491 118L573 118L573 127L655 127L655 121L736 121L736 145L818 145L818 163L900 163L900 121L900 77L900 89L818 89L818 68L736 68L736 56L655 56L655 74L573 74L573 80L491 80L491 50L409 50L409 53L327 53L327 71L245 71L245 65L164 65L164 86L82 86L82 65L0 65Z",
    fill: "#0077e7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 163L82 163L82 253L164 253L164 265L245 265L245 235L327 235L327 199L409 199L409 235L491 235L491 235L573 235L573 253L655 253L655 253L736 253L736 196L818 196L818 250L900 250L900 178L900 119L900 161L818 161L818 143L736 143L736 119L655 119L655 125L573 125L573 116L491 116L491 92L409 92L409 128L327 128L327 134L245 134L245 146L164 146L164 149L82 149L82 104L0 104Z",
    fill: "#0073e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 301L82 301L82 301L164 301L164 301L245 301L245 301L327 301L327 301L409 301L409 301L491 301L491 301L573 301L573 301L655 301L655 301L736 301L736 301L818 301L818 301L900 301L900 301L900 176L900 248L818 248L818 194L736 194L736 251L655 251L655 251L573 251L573 233L491 233L491 233L409 233L409 197L327 197L327 233L245 233L245 263L164 263L164 251L82 251L82 161L0 161Z",
    fill: "#006ee3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanding2);
export default __webpack_public_path__ + "static/media/landing-2.77af8a84ba96a08cef0873e497a8284f.svg";
export { ForwardRef as ReactComponent };